import { Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react"
import { IterationRow } from "component/mapping/iteration/IterationRow"
import { stickyHeaderCellProps } from "component/table/stickyHeader"
import { FC } from "react"
import { IterationListItem } from "type/mapping/iteration"

interface IterationsTableProps {
  iterations: IterationListItem[]
}

// Документ и объект делят оставшееся место поровну, остальные — фиксированной
// ширины (статус "Нужно проверить" — самый длинный бейдж)
const COLUMNS: { title: string; width?: string }[] = [
  { title: "Документ" },
  { title: "Объект" },
  { title: "Тип", width: "96px" },
  { title: "Статус", width: "184px" },
  { title: "Создана", width: "112px" },
  { title: "", width: "132px" },
]

// История сопоставлений — в том же виде, что таблица на странице проверки
export const IterationsTable: FC<IterationsTableProps> = (props) => {
  const { iterations } = props

  return (
    <Table w="full" variant="simple" sx={{ tableLayout: "fixed" }}>
      <Thead>
        <Tr>
          {COLUMNS.map((column, index) => (
            <Th key={index} w={column.width} px={3} py={2} {...stickyHeaderCellProps}>
              {column.title}
            </Th>
          ))}
        </Tr>
      </Thead>

      <Tbody>
        {iterations.map((iteration) => (
          <IterationRow key={iteration.id} iteration={iteration} />
        ))}

        {iterations.length === 0 && (
          <Tr>
            <Td colSpan={COLUMNS.length} py={10} textAlign="center" color="gray.500">
              Ничего не нашлось
            </Td>
          </Tr>
        )}
      </Tbody>
    </Table>
  )
}
